import { Link } from "react-router-dom";
import { Badge } from "@/components/ui/badge";

interface GuestResourceSubjectsProps {
  subjects: string[];
}

export function GuestResourceSubjects({ subjects }: GuestResourceSubjectsProps) {
  return (
    <div>
      <h2 className="mb-2 text-sm font-semibold text-gray-900">Subjects</h2>
      <div className="flex flex-wrap gap-2">
        {subjects.map((subject) => (
          <Link key={subject} to={`/opac?q=${encodeURIComponent(subject)}&type=all`}>
            <Badge
              variant="outline"
              className="bg-gray-50 text-gray-700 transition-colors duration-200 hover:bg-primary/5"
            >
              {subject}
            </Badge>
          </Link>
        ))}
      </div>
    </div>
  );
}
